/* eslint-disable no-undef */
import EventEmitter from './EventEmitter.js';
import Events from './Events.js';

export default class Time {
    constructor() {
        // Setup
        this.start = Date.now();
        this.current = this.start;
        this.elapsedTime = 0;
        this.delta = 16; // Default value for 60Hz screen

        // Event handling
        this.eventEmitter = new EventEmitter();

        // We wait a frame to call tick because in the very first frame the delta can be 0,
        // possibly causing problems.
        window.requestAnimationFrame(() => {
            this.tick();
        });
    }

    tick() {
        const currentTime = Date.now();
        this.delta = currentTime - this.current;
        this.current = currentTime;
        this.elapsedTime = this.current - this.start;

        this.eventEmitter.trigger(Events.TICK);

        window.requestAnimationFrame(() => {
            this.tick();
        });
    }
}
